import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { InstructionsPage } from '@/features/siteplan/instructions-page';

const searchSchema = z.object({
  instruction: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/site/instructions')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const { instruction } = Route.useSearch();
  return <InstructionsPage projectId={projectId} instructionId={instruction} />;
}
